<dialog #dialog [id]="modalId" class="modal">
  <div class="modal-box max-w-md bg-base-100">
    <h2 class="text-lg font-semibold text-primary mb-2">Delete validation rule?</h2>
    <p class="text-sm text-base-content mb-4" *ngIf="pending">
      You are about to delete a
      <span class="font-semibold">{{ pending.kind === 'field' ? 'field' : 'cross-field' }}</span>
      rule of type
      <code class="text-xs bg-base-200 px-1 rounded">{{ pending.rule.rule_type }}</code
      >. This action cannot be undone.
    </p>
    <p class="text-xs text-base-content/70 mb-4">
      Tip: if you only want to disable the rule temporarily, untick the Active toggle on the row
      instead.
    </p>
    <div class="flex justify-end gap-2">
      <button
        type="button"
        (click)="onCancel()"
        class="h-9 px-4 border border-base-300 rounded text-sm text-dark font-medium hover:bg-base-200 transition-colors"
      >
        Cancel
      </button>
      <button
        type="button"
        (click)="onConfirm()"
        class="h-9 px-4 border border-red-300 bg-red-600 text-white rounded text-sm font-medium hover:bg-red-700 transition-colors"
      >
        Delete
      </button>
    </div>
  </div>
  <form method="dialog" class="modal-backdrop">
    <button (click)="onCancel()">close</button>
  </form>
</dialog>
